import React from 'react';
import {useIntl} from 'react-intl';

import {isProductSearchHitModel} from 'coreClasses/search/ProductSearchHitModel';

import Button from 'brandComponents/Button';

import {useProductHitContext} from '../../ProductHitContext';

import {IProductHitCta} from './IProductHitCta';
import messages from './messages';

const ProductHitCta = ({classNames}: IProductHitCta) => {
	const {product} = useProductHitContext();
	const intl = useIntl();

	if (!product || isProductSearchHitModel(product)) {
		return null;
	}

	const url = product.getProductUrl();

	return (
		<Button
			url={url}
			classNames={classNames}
			variant="tertiary"
		>
			{intl.formatMessage(messages.shopNow)}
		</Button>
	);
};

export default ProductHitCta;
